// Service public — confirmation d'intervention d'un formateur sur une session.
// Aucune authentification : appels fetch directs (miroir de
// public-vendor-contract.ts).
//
// - SPA route : `/formateur/invitation/:token`
// - API JSON  : `/api/v1/public/instructor-invitations/:token`

import { publicGet, publicPost } from "./public-fetch"

const API_PATH = "/api/v1/public/instructor-invitations"

export type InstructorInvitationStatus = "pending" | "confirmed" | "declined"

export interface PublicInstructorInvitation {
  instructor_name: string
  session_title: string
  session_code: string
  start_date: string
  end_date: string
  company_name: string
  status: InstructorInvitationStatus
}

export interface RespondInstructorInvitationResponse {
  status: "confirmed" | "declined"
}

export function getPublicInstructorInvitation(token: string): Promise<PublicInstructorInvitation> {
  return publicGet<PublicInstructorInvitation>(`${API_PATH}/${token}`)
}

export function respondPublicInstructorInvitation(
  token: string,
  accept: boolean,
  declineReason?: string,
): Promise<RespondInstructorInvitationResponse> {
  return publicPost<RespondInstructorInvitationResponse>(`${API_PATH}/${token}/respond`, {
    accept,
    decline_reason: declineReason,
  })
}
